import { environment } from "../../environments/environment";


export const API_CONFIG = {
  baseUrl: environment.apiUrl,
  modules: {

    expenses: {
      base: '/transactions',
      endpoints: {
        list: '',
        filter: '',
        create: '',
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
        deleteMultiple: (ids: string[]) => `?transactionId=${ids.join('&transactionId=')}`,
      }
    },

    prompts: {
      endpoints: {
        process: '/process-message',
      }
    },

    dashboard: {
      base: '/dashboard',
      endpoints: {
        summary: '/summary',
        analytics: {
          stats: '/analytics/stats',
          heatmap: '/analytics/heatmap',
          expensesByCategory: '/analytics/expenses-by-category',
          monthlyBalance: '/analytics/monthly-balance',
          expenseHistory: '/analytics/expense-history',
          cashFlow: '/analytics/cash-flow'
        }
      }
    },

    auth: {
      base: '/auth',
      endpoints: {
        login: '/login',
        register: '/register',
        google: '/google',
        refresh: '/refresh'
      }
    },

    user: {
      base: '/users',
      endpoints: {
        update: '/me',
        income: '/me/income'
      }
    },

    categories: {
      base: '/categories',
      endpoints: {
        list: '',
        create: '',
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
      }
    },

    fixedExpenses: {
      base: '/fixed-expenses',
      endpoints: {
        list: '',
        create: '',
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
        deleteMultiple: '',
        templates: '/templates',
        invoices: (expenseId: string) => `/${expenseId}/invoices`,
        payInvoice: (expenseId: string, invoiceId: string) => `/${expenseId}/invoices/${invoiceId}/pay`,
        skipInvoice: (expenseId: string, invoiceId: string) => `/${expenseId}/invoices/${invoiceId}/skip`,
        revertInvoice: (expenseId: string, invoiceId: string) => `/${expenseId}/invoices/${invoiceId}/revert`,
      }
    },

    cards: {
      base: '/credit-cards',
      endpoints: {
        cards: {
          list: '',
          create: '',
          update: (cardId: string) => `/${cardId}`,
          delete: (cardId: string) => `/${cardId}`,
          summary: (cardId: string) => `/summary/${cardId}`,
          statement: (statementId: string) => `/statements/${statementId}`,
          overview: '/overview',
          dashboard: '/dashboard',
        },
        expenses: {
          create: '/expenses',
          active: (cardId: string) => `/expenses?card_id=${cardId}&current_period=true`,
          activeAll: '/expenses?current_period=true',
          byPeriod: (cardId: string, month: number, year: number) => `/expenses?card_id=${cardId}&period=${year}-${String(month).padStart(2, '0')}`,
          update: (expenseId: string) => `/expenses/${expenseId}`,
          cancel: (expenseId: string) => `/expenses/${expenseId}/cancel`,
          delete: (expenseId: string) => `/expenses/${expenseId}`
        }
      }
    },

    groups: {
      base: '/groups',
      endpoints: {
        list: '',
        create: '',
        detail: (id: string) => `/${id}`,
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
        invite: (id: string) => `/${id}/invite`,
        join: (token: string) => `/join/${token}`,
        removeMember: (groupId: string, memberId: string) => `/${groupId}/members/${memberId}`,
        settle: (groupId: string) => `/${groupId}/settle`,
        groupFixedExpenses: (groupId: string) => `/${groupId}/fixed-expenses`,
        groupFixedExpensesSummary: (groupId: string) => `/${groupId}/fixed-expenses/summary`,
        incomeReminder: (groupId: string, memberId: string) => `/${groupId}/members/${memberId}/income-reminder`,
      }
    },

    wallets: {
      base: '/wallets',
      endpoints: {
        list: '',
        create: '',
        totalBalance: '/total-balance',
        detail: (id: string) => `/${id}`,
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
        setDefault: (id: string) => `/${id}/set-default`,
        transfer: (id: string) => `/${id}/transfer`,
        balanceCorrection: (id: string) => `/${id}/balance-correction`,
        movements: (id: string) => `/${id}/movements`,
      }
    },

    envelopes: {
      base: '/envelopes',
      endpoints: {
        list: '',
        create: '',
        detail: (id: string) => `/${id}`,
        update: (id: string) => `/${id}`,
        delete: (id: string) => `/${id}`,
        allocate: (id: string) => `/${id}/allocate`,
        deallocate: (id: string) => `/${id}/deallocate`,
        rules: '/rules',
        updateRule: (id: string) => `/rules/${id}`,
        deleteRule: (id: string) => `/rules/${id}`,
        distribute: '/distribute',
      }
    },

    dolar: {
      base: '/dolar',
      endpoints: {
        rates: '/rates',
      }
    },

    config: {
      base: '',
      endpoints: {
        get: '/config',
        adminPermissions: '/admin/permissions',
      }
    },

    mercadopago: {
      base: '/mercadopago',
      endpoints: {
        connect: '/connect',
        status: '/status',
        sync: '/sync',
        disconnect: '/disconnect',
        pendingExpenses: '/pending-expenses',
        assignPendingExpense: (id: string) => `/pending-expenses/${id}/assign`,
        dismissPendingExpense: (id: string) => `/pending-expenses/${id}`,
        contacts: '/contacts',
        updateContact: (mpId: string) => `/contacts/${mpId}`,
      }
    }
  }
};
